module.exports = __webpack_public_path__ + "img/plane-departure.8e4a2fec.svg";